import React from "react";
import styled from "styled-components";
import loadable from "@loadable/component";

import { sectionRhythm } from "../../../theme";
import { PageSection } from "../../components/layout/layout-styles";
import { ClearPictureContentFallback } from "../../components/layout/section-skeleton";

const ClearPictureCard = loadable(() => import("./clear-picture-card"));

const Section = styled(PageSection)`
  margin: 0 auto;
  width: 94%;
  max-width: 1040px;
  /* Extra bottom space — gap below reads tighter than above */
  padding-bottom: ${sectionRhythm.paddingY.mobile * 2}px;

  @media only screen and (min-width: ${sectionRhythm.breakpoint}) {
    padding-bottom: ${sectionRhythm.paddingY.desktop * 2}px;
  }
`;

const ClearPictureSection = () => {
  return (
    <Section name="clear-picture" as="section">
      <ClearPictureCard fallback={<ClearPictureContentFallback />} />
    </Section>
  );
};

export default ClearPictureSection;
